import { sbaAxios } from "../utils/sbaAxios";
import { getpricinglist } from "../../config/apiConfig";
import {
    FETCH_ASSETPRICING_BEGIN,
    FETCH_ASSETPRICING_SUCCESS,
    FETCH_ASSETPRICING_FAILURE
} from '../constants/pricing';

export const getAssetPricingAction = (AssetId,pricingdate) => {
    return (dispatch) => {
        dispatch(fetchAssetpricingBegin());
        sbaAxios({
            url: `${getpricinglist}${AssetId},${pricingdate}`,
            method: 'get',
        })
            .then((repos) => {
                const AssetpricingList = repos;
                dispatch(fetchAssetpricingSuccess(AssetpricingList));
                return AssetpricingList;
            })
            .catch((error) => dispatch(fetchAssetpricingFailure(error)));
    };
}

export const fetchAssetpricingBegin = () => ({
    type: FETCH_ASSETPRICING_BEGIN,
});

export const fetchAssetpricingSuccess = (AssetpricingList) => ({
    type: FETCH_ASSETPRICING_SUCCESS,
    payload: { AssetpricingList },
});


export const fetchAssetpricingFailure = (errorMessage) => ({
    type: FETCH_ASSETPRICING_FAILURE,
    payload: { errorMessage }
});
